<div class="modal fade" id="odd-hours-model-popup" tabindex="-1" role="dialog" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <form action="javascript:;" (submit)="ConfirmedSave($event)">
                <input type="hidden" name="asset_id" value="{{asset_id}}">
                <div class="modal-header bg-primary">
                    <h6 class="modal-title">Odd Hours!</h6>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="form-group col-sm-12 col-md-12 text-right pb-0 mb-0">
                            <button type="button" name="add_more" (click)="addSection()" class="btn btn-primary btn-right">+</button>
                        </div>
                    </div>
                    <div *ngFor="let section of sections; let i = index" class="row">
                        <div [innerHTML]="section" class="row col-md-10">
                        </div>
                        <div class="form-group col-sm-2 col-md-2">
                            <button (click)="deleteSection(i)" type="button" class="btn btn-danger mt-4"><span class="fa fa-trash"></span></button>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-link" data-dismiss="modal">Close</button>
                    <button type="submit" class="btn bg-primary">Save changes</button>
                </div>
            </form>
        </div>
    </div>
</div>
